import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface Enseignant {
  _id?: string,
  nom_enseignant: string,
  prenom_enseignant: string,
  phone: string,
  matiere?: string
}

export const enseignantSlice = createApi({
  reducerPath: "Enseignant",
  baseQuery: baseQueryWithAuth("enseignants"),
  tagTypes: ["Enseignant"],
  endpoints(builder) {
    return {
      fetchEnseignants: builder.query<Enseignant[], number | void>({
        query() {
          return `/getEnseignants`;
        },
        providesTags: ["Enseignant"],
      }),
      fetchEnseignantId: builder.query<Enseignant, string | void>({
        query: (_id) => ({
          url: `/getEnseignant/${_id}`,
          method: "GET",
        }),
        providesTags: ["Enseignant"],
      }),
      addEnseignant: builder.mutation<void, Enseignant>({
        query(payload) {
          return {
            url: "/newEnseignant",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Enseignant"],
      }),
      updateEnseignant: builder.mutation<void, Enseignant>({
        query: ({ _id, ...rest }) => ({
          url: `/updateEnseignant/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["Enseignant"],
      }),
      deleteEnseignant: builder.mutation<void, Enseignant>({
        query: (_id) => ({
          url: `/deleteEnseignant/${_id}`,
          method: "Delete",
        }),
        invalidatesTags: ["Enseignant"],
      }),
    };
  },
});

export const {
 useAddEnseignantMutation,
 useFetchEnseignantsQuery,
 useDeleteEnseignantMutation,
 useUpdateEnseignantMutation,
 useFetchEnseignantIdQuery
} = enseignantSlice;